// NPM
import React from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

function getPercent(val, withSymbol = false) {
  if (val === "") return "";
  return `${parseFloat(val).toFixed(1)}${withSymbol ? "%" : ""}`;
}

function VoteShareTile(props) {
  const parties = useSelector((state) => state.parties.value);

  if (parties.length === 0) {
    return null;
  }

  const party = parties.find((p) => p.id === props.voteShare.party);

  if (!party) {
    return null;
  }

  const { voteShare } = props;

  return (
    <div className="VoteShareTile" style={{ color: party.color }}>
      <div className="VoteShareTile__inner">
        <div className="VoteShareTile__party">
          <img className="VoteShareTile__party-image" src={party.image} />
          <div className="VoteShareTile__party-name">{party.friendlyName}</div>
          <div className="VoteShareTile__party-code">{party.short}</div>
        </div>
        <div className="VoteShareTile__median">
          {`${getPercent(voteShare.median, true)}`}
        </div>

        <div className="VoteShareTile__confidence">
          <div className="VoteShareTile__confidence-lower">
            <div className="VoteShareTile__confidence-label">Low</div>
            <div className="VoteShareTile__confidence-value">
              {getPercent(voteShare.lower)}
            </div>
          </div>

          <div className="VoteShareTile__confidence-upper">
            <div className="VoteShareTile__confidence-label">High</div>
            <div className="VoteShareTile__confidence-value">
              {getPercent(voteShare.upper)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VoteShareTile;
